import React, { Fragment, useState, useEffect, useRef } from "react";
import { useNavigate } from "react-router-dom";

import { useParams } from "react-router-dom";
import { Row, Col, Nav, Tab, Card, Dropdown } from "react-bootstrap";
import { FiUser, FiCalendar, FiEdit } from "react-icons/fi";
import "../../assets/css/details.css";
import {
  getDepartmentList,
  deleteDepartmentUser,
  getDepartmentUsersList,
  deleteDepartment,
  updateDepartmentStatus,
  updateDepartment,
  getDepartmentDetails,
} from "../../services/Users-services";
import { useSharedState, useGlobalState } from "../../services/hostelConst.js";
import { getOrganizationLevel } from "../../services/OrganisationServices/organizationLevel";
import { showErrorMessages } from "../../services/utilityFunctions.js";
import MasterTable from "../../views/dashboard/widget/MasterTabel.js";
import MasterTable2 from "../../views/dashboard/widget/MasterTabe2";
import AddGroupUserForm from "../../components/FormComponents/AddGroupuser";
import { getLocalStorageData } from "../../services/axiosComponent";
import DetailsPageNavigation from "../../views/dashboard/widget/detailsPageNavigation";
import MasterActions from "../../views/dashboard/widget/MasterActions";
import { getMethods } from "../../services/utilityFunctions";
import AddGroupForm from "../../components/FormComponents/AddGroups";
import AddDepartmentUser from "../../components/DepartmentManagementCompo/AddDepartmentUser.js";
import AddDepartmentForm from "../FormComponents/AddDepartment";
const DepartmentDetailsPage = ({ navigate }) => {
  var navigate = navigate;
  const [sharedState, setSharedState] = useSharedState();
  var { id } = useParams();
  const { modalState, openModal } = useGlobalState();
  const [details, setDetails] = useState(null);
  const [loading, setLoading] = useState(true);
  const [methods, setMethods] = useState({});
  const [groupLevelList, setGroupLevelList] = useState([]);

  const getGroupLevelList = async () => {
    var res = await getOrganizationLevel({
      type: "GROUP",
      organizationId:
        getLocalStorageData("profileDetails")["_ORGANIZATION_"]._ID,
    });
    if (res.status === "success") {
      var list = [];
      res.data.map((item) => {
        list.push({ value: item._ID, label: item.NAME });
      });

      return list;
    } else {
      showErrorMessages({ data: res, navigate });
      return [];
    }
  };
  const userId = getLocalStorageData("profileDetails")._ID;
  const fetchDetails = async ({ id, isLoading = true }) => {
    if (isLoading) setLoading(true);

    var res = await getGroupLevelList();
    const response = await getDepartmentDetails(id);
    if (response.status === "success") {
      console.log("response", response.data);
      setGroupLevelList(res);
      setMethods(await getMethods("User Management", "Department Users"));
      setDetails(response.data);
    } else {
      showErrorMessages({ data: response, navigate });
    }
    if (isLoading) setLoading(false);
  };
  const isInitialMount = useRef(true);

  useEffect(() => {
    if (isInitialMount.current) {
      isInitialMount.current = false;
      openModal({ ...modalState, id: id });
    }
    fetchDetails({ id });
  }, []);

  return (
    <Fragment>
      {loading ? (
        <center>
          <div class="spinner-border text-primary" role="status">
     
          </div>
        </center>
      ) : (
        <Row className="mb-3">
          <Row className="mb-1  pb-0">
            <Col lg="12" className="mb-0 pb-0 ">
              <Card
                className="position-relative border-0  transition-all "
                style={{ borderRadius: "1rem", transition: "0.3s" }}
              >
                <Card.Body className="p-3 px-lg-4 py-lg-3">
                  <Row className="">
                    {/* Left Section */}
                    <Col lg="9">
                      <div className="">
                        <DetailsPageNavigation
                          list={["Departments", "Details"]}
                        />
                        <div className="d-flex align-items-start gap-2 mb-2">
                          <h3
                            className="mb-0 fw-bold fs-4 text-truncate"
                            style={{
                              background:
                                "linear-gradient(45deg, #2b2b2b, #4a4a4a)",
                              WebkitBackgroundClip: "text",
                              WebkitTextFillColor: "transparent",
                            }}
                          >
                            {details?.NAME}
                          </h3>
                        </div>
                        <p
                          className="text-muted mb-2 fs-6"
                          style={{
                            lineHeight: 1.5,
                            display: "-webkit-box",
                            WebkitLineClamp: 2,
                            WebkitBoxOrient: "vertical",
                            overflow: "hidden",
                            textOverflow: "ellipsis",
                          }}
                        >
                          {details?.DESCRIPTION || "No description available"}
                        </p>
                      </div>
                    </Col>
                    {/* Right Section */}
                    <Col lg="3" className="">
                      <div className="d-flex flex-column gap-1 justify-content-end">
                        <div className="d-flex align-items-center gap-1 p-1 hover-bg-light rounded-2 small">
                          <div
                            className="bg-light rounded-circle p-1 me-2 d-flex align-items-center justify-content-center"
                            style={{ width: 28, height: 28 }}
                          >
                            <FiUser className="text-primary fs-6" />
                          </div>
                          <div>
                            <div
                              className={`text-dark fw-medium`}
                              style={{ fontSize: "0.875rem" }}
                            >
                              {details["_DEPARTMENT HEAD_"]["NAME"]}
                            </div>

                            {/* <small className="text-muted">{subLabel}</small> */}
                          </div>
                        </div>
                        <div className="d-flex align-items-center gap-1 p-1 hover-bg-light rounded-2 small">
                          <div
                            className="bg-light rounded-circle p-1 me-2 d-flex align-items-center justify-content-center"
                            style={{ width: 28, height: 28 }}
                          >
                            <FiCalendar className="text-success fs-6" />
                          </div>
                          <div>
                            <div
                              className={`text-dark fw-medium`}
                              style={{ fontSize: "0.875rem" }}
                            >
                              {details["LAST MODIFIED"]}
                            </div>

                            {/* <small className="text-muted">{subLabel}</small> */}
                          </div>
                        </div>
                        <div className="d-flex align-items-center gap-1 p-1 hover-bg-light rounded-2 small">
                          <div
                            className="bg-light rounded-circle p-1 me-2 d-flex align-items-center justify-content-center"
                            style={{ width: 28, height: 28 }}
                          >
                            <FiEdit className="text-warning fs-6" />
                          </div>
                          <div>
                            <div
                              className={`text-dark fw-medium`}
                              style={{ fontSize: "0.875rem" }}
                            >
                              {details["MODIFIED BY"]}
                            </div>

                            {/* <small className="text-muted">{subLabel}</small> */}
                          </div>
                        </div>
                        {
                          <div className="d-flex align-items-center gap-1 p-1 hover-bg-light rounded-2 small">
                            <div
                              className="bg-light rounded-circle p-1 me-2 d-flex align-items-center justify-content-center"
                              style={{ width: 28, height: 28 }}
                            >
                              <MasterActions
                                actions={{
                                  edit: true,
                                  delete: true,
                                  status: true,
                                }}
                                title="Department"
                                AddForm={
                                  <AddDepartmentForm
                                    navigate={navigate}
                                    refresh={() => {
                                      fetchDetails({ id, isLoading: false });
                                    }}
                                  />
                                }
                                refresh={() => {
                                  fetchDetails({ id, isLoading: false });
                                }}
                                methods={methods}
                                deleteRow={deleteDepartment}
                                updateStatus={updateDepartmentStatus}
                                updateRow={updateDepartment}
                                isDetailsPage={true}
                                item={details}
                              />
                            </div>
                            <div>
                              <div
                                className={`text-dark fw-medium`}
                                style={{ fontSize: "0.875rem" }}
                              >
                                {"Show Options"}
                              </div>

                              {/* <small className="text-muted">{subLabel}</small> */}
                            </div>
                          </div>
                        }
                      </div>
                    </Col>
                  </Row>
                </Card.Body>
              </Card>
            </Col>
          </Row>

          <Row className="mt-0">
            <Col lg="12">
              {/* <MasterTable2
                tab1={"User Management"}
                tab2={"Department Users"}
                deleteFun={deleteDepartmentUser}
                getList={getDepartmentUsersList}
                groupLevelList={groupLevelList}
                adminId={details["_DEPARTMENT HEAD_"]["_ID"]}
                departmentId={details["_ID"]}
                columns={["DISPLAY NAME", "GROUP LEVEL"]}
                details={details}
                AddForm={AddGroupUserForm}
                actions={{
                  delete: true,
                }}
                isAdmin={details["_IS ADMIN"] == "Y" ? true : false}
                title={"Group Users"}
                methods={{ DELETE: 1 }}
                subTitle={"User"}
              /> */}

              <MasterTable
                tab1={"User Management"}
                tab2={"Department Users"}
                userId={userId}
                getTableData={getDepartmentUsersList}
                departmentId={id}
                deleteRow={deleteDepartmentUser}
                getList={getDepartmentUsersList}
                details={details}
                AddForm={AddDepartmentUser}
                actions={{
                  delete: true,
                }}
              />
            </Col>
          </Row>
        </Row>
      )}
    </Fragment>
  );
};

export default DepartmentDetailsPage;
